import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";
import { VISITOR_API_ROUTES } from "../utils/visitorApiRoutes";
import { buildApiError, parseJson } from "./apiHelpers";

export async function getVisitorDashboard({ scope = "self" } = {}) {
  const qs = scope ? `?scope=${encodeURIComponent(scope)}` : "";
  const res = await authFetch(`${VISITOR_API_ROUTES.visitors}/dashboard${qs}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to fetch visitor dashboard");
  return data;
}
